import { render, staticRenderFns } from "./ExamineResult.vue?vue&type=template&id=0c39db8e&scoped=true&"
import script from "./ExamineResult.vue?vue&type=script&lang=js&"
export * from "./ExamineResult.vue?vue&type=script&lang=js&"
import style0 from "./ExamineResult.vue?vue&type=style&index=0&id=0c39db8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c39db8e",
  null
  
)

export default component.exports